import { defineMessages } from "@/i18n";
import en from "./en";

export const settingsProjectsMessages = defineMessages("settings-projects", en);
